import React from 'react';
import { Box, Divider, Stack } from '@mui/material';
import { useTicketsSelected } from '@/store';
import TicketSummary from '../tickets/TicketSummary';
import BackButton from '../../components/BackButton';
import BookingSummary from './BookingSummary';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import PromotionButton from '@/sections/promotion/PromotionButton';
import PromotionBanner from '@/sections/promotion/PromotionBanner';

export default function EventTickets({ onBack = () => { } }) {
  const { hasTickets } = useTicketsSelected();
  const { clickedOnBackButton } = useAnalyticsEvents();
  const onBackHandler = () => {
    onBack();
    clickedOnBackButton();
  };
  return (
    <Box>
      <BackButton onClick={onBackHandler} />
      <Box
        sx={{
          height: '39px'
        }}
      >
        <Box
          sx={{
            'width': '100%',
            'mt': 2,
            'mb': 2,
          }}
        />
      </Box>
      <Box
        sx={{
          mr: '24px',
          ml: '24px',
        }}
      >
        <BookingSummary changeView={onBackHandler} />
      </Box>
      {hasTickets && (
        <Box
          sx={{
            height: '100px',
            width: '100%',
          }}
        ></Box>
      )}
    </Box>
  );
}
